import eventsReducer from "./reducer"
import eventsSaga from "./sagas"

const saga = {
  reducers: eventsReducer,
  sagas: eventsSaga
}

export default saga